"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAbsolute = exports.isUrl = exports.isExternal = exports.isAsset = exports.fixRelativeUrls = exports.collectAssets = exports.assureRelativeUrlPrefix = exports.createStylableFileProcessor = exports.STYLABLE_VALUE_MATCHER = exports.animationPropRegExp = exports.mixinDeclRegExp = exports.STYLABLE_NAMED_MATCHER = exports.stValuesMap = exports.stValues = exports.rootValueMapping = exports.valueMapping = exports.SBTypesParsers = exports.createMinimalFS = exports.StylableResolver = exports.isInPath = exports.transformMatchesOnRule = exports.mergeRules = exports.isValidDeclaration = exports.isValidClassName = exports.getSourcePath = exports.getAlias = exports.findDeclaration = exports.expandCustomSelectors = exports.CUSTOM_SELECTOR_RE = exports.transformerWarnings = exports.StylableTransformer = exports.RESERVED_ROOT_NAME = exports.createDefaultResolver = exports.paramMapping = exports.globalValueRegExp = exports.isCSSVarProp = exports.generateScopedCSSVar = exports.ensureStylableImports = exports.parseStylableImport = exports.process = exports.validateScopingSelector = exports.processorWarnings = exports.createEmptyMeta = exports.StylableProcessor = exports.scopeCSSVar = exports.reservedKeyFrames = exports.cachedProcessFile = exports.safeParse = exports.cssParse = exports.cssObjectToAst = void 0;
exports.isGlobal = exports.isRootValid = exports.isSimpleSelector = exports.isImport = exports.matchAtKeyframes = exports.matchAtMedia = exports.mergeChunks = exports.separateChunks2 = exports.separateChunks = exports.filterChunkNodesByType = exports.fixChunkOrdering = exports.matchSelectorTarget = exports.findRule = exports.removeUnusedRules = exports.createSubsetAst = exports.scopeSelector = exports.getDeclStylable = exports.getOriginDefinition = exports.createWarningRule = exports.isChildOfAtRule = exports.isCompRoot = exports.strategies = exports.validateAllowedNodesUntil = exports.listOptions = exports.groupValues = exports.getStringValue = exports.getNamedArgs = exports.getFormatterArgs = exports.getRuleScopeSelector = exports.pseudoStates = exports.murmurhash3_32_gc = exports.visitMetaCSSDependenciesBFS = exports.emitDiagnostics = exports.packageNamespaceFactory = exports.noCollisionNamespace = exports.nativePseudoElements = exports.nativePseudoClasses = exports.nativeFunctionsDic = exports.isCssNativeFunction = exports.systemValidators = exports.unbox = exports.stTypes = exports.isCustomValue = exports.getBoxValue = exports.createCustomValue = exports.box = exports.CustomValueStrategy = exports.evalDeclarationValue = exports.resolveArgumentsValue = exports.functionWarnings = void 0;
exports.createSimpleSelectorChecker = exports.stringifySelector = exports.parseSelector = exports.traverseNode = exports.isNodeMatch = exports.isNested = exports.createChecker = void 0;
const deprecation_1 = require("./helpers/deprecation");
var parser_1 = require("./parser");
Object.defineProperty(exports, "cssObjectToAst", { enumerable: true, get: function () { return parser_1.cssObjectToAst; } });
Object.defineProperty(exports, "cssParse", { enumerable: true, get: function () { return parser_1.cssParse; } });
const parser_2 = require("./parser");
/**@deprecated*/
exports.safeParse = (0, deprecation_1.wrapFunctionForDeprecation)(parser_2.safeParse, {
    name: `safeParse`,
    pleaseUse: `postcss-safe-parser`,
});
var cached_process_file_1 = require("./cached-process-file");
Object.defineProperty(exports, "cachedProcessFile", { enumerable: true, get: function () { return cached_process_file_1.cachedProcessFile; } });
var css_keyframes_1 = require("./features/css-keyframes");
Object.defineProperty(exports, "reservedKeyFrames", { enumerable: true, get: function () { return css_keyframes_1.reservedKeyFrames; } });
const css_custom_property_1 = require("./features/css-custom-property");
/**@deprecated*/
exports.scopeCSSVar = (0, deprecation_1.wrapFunctionForDeprecation)(css_custom_property_1.scopeCSSVar, {
    name: `scopeCSSVar`,
    pleaseUse: `stylable.transformCustomProperty`,
});
var stylable_processor_1 = require("./stylable-processor");
Object.defineProperty(exports, "StylableProcessor", { enumerable: true, get: function () { return stylable_processor_1.StylableProcessor; } });
Object.defineProperty(exports, "createEmptyMeta", { enumerable: true, get: function () { return stylable_processor_1.createEmptyMeta; } });
Object.defineProperty(exports, "processorWarnings", { enumerable: true, get: function () { return stylable_processor_1.processorWarnings; } });
Object.defineProperty(exports, "validateScopingSelector", { enumerable: true, get: function () { return stylable_processor_1.validateScopingSelector; } });
const stylable_processor_2 = require("./stylable-processor");
/**@deprecated*/
exports.process = (0, deprecation_1.wrapFunctionForDeprecation)(stylable_processor_2.process, {
    name: `process`,
    pleaseUse: `stylable.analyze`,
});
const import_1 = require("./helpers/import");
/**@deprecated*/
exports.parseStylableImport = (0, deprecation_1.wrapFunctionForDeprecation)(import_1.parseModuleImportStatement, {
    name: `parseStylableImport`,
    pleaseUse: `import { parseModuleImportStatement } from '@stylable/core'`,
});
/**@deprecated*/
exports.ensureStylableImports = (0, deprecation_1.wrapFunctionForDeprecation)(import_1.ensureModuleImport, {
    name: `ensureStylableImports`,
    pleaseUse: `import { ensureModuleImport } from '@stylable/core'`,
});
var css_custom_property_2 = require("./helpers/css-custom-property");
Object.defineProperty(exports, "generateScopedCSSVar", { enumerable: true, get: function () { return css_custom_property_2.generateScopedCSSVar; } });
const css_custom_property_3 = require("./helpers/css-custom-property");
/**@deprecated*/
exports.isCSSVarProp = (0, deprecation_1.wrapFunctionForDeprecation)(css_custom_property_3.validateCustomPropertyName, {
    name: `isCSSVarProp`,
    pleaseUse: `import { validateCustomPropertyName } from '@stylable/core'`,
});
var global_1 = require("./helpers/global");
Object.defineProperty(exports, "globalValueRegExp", { enumerable: true, get: function () { return global_1.globalValueRegExp; } });
const global_2 = require("./helpers/global");
/**@deprecated*/
exports.paramMapping = {
    global: global_2.GLOBAL_FUNC,
};
var module_resolver_1 = require("./module-resolver");
Object.defineProperty(exports, "createDefaultResolver", { enumerable: true, get: function () { return module_resolver_1.createDefaultResolver; } });
var stylable_meta_1 = require("./stylable-meta");
Object.defineProperty(exports, "RESERVED_ROOT_NAME", { enumerable: true, get: function () { return stylable_meta_1.RESERVED_ROOT_NAME; } });
var stylable_transformer_1 = require("./stylable-transformer");
/** @deprecated use stylable.transform / stylable.transformSelector... */
Object.defineProperty(exports, "StylableTransformer", { enumerable: true, get: function () { return stylable_transformer_1.StylableTransformer; } });
Object.defineProperty(exports, "transformerWarnings", { enumerable: true, get: function () { return stylable_transformer_1.transformerWarnings; } });
var stylable_utils_1 = require("./stylable-utils");
Object.defineProperty(exports, "CUSTOM_SELECTOR_RE", { enumerable: true, get: function () { return stylable_utils_1.CUSTOM_SELECTOR_RE; } });
Object.defineProperty(exports, "expandCustomSelectors", { enumerable: true, get: function () { return stylable_utils_1.expandCustomSelectors; } });
Object.defineProperty(exports, "findDeclaration", { enumerable: true, get: function () { return stylable_utils_1.findDeclaration; } });
Object.defineProperty(exports, "getAlias", { enumerable: true, get: function () { return stylable_utils_1.getAlias; } });
Object.defineProperty(exports, "getSourcePath", { enumerable: true, get: function () { return stylable_utils_1.getSourcePath; } });
Object.defineProperty(exports, "isValidClassName", { enumerable: true, get: function () { return stylable_utils_1.isValidClassName; } });
Object.defineProperty(exports, "isValidDeclaration", { enumerable: true, get: function () { return stylable_utils_1.isValidDeclaration; } });
Object.defineProperty(exports, "mergeRules", { enumerable: true, get: function () { return stylable_utils_1.mergeRules; } });
Object.defineProperty(exports, "transformMatchesOnRule", { enumerable: true, get: function () { return stylable_utils_1.transformMatchesOnRule; } });
var stylable_resolver_1 = require("./stylable-resolver");
Object.defineProperty(exports, "isInPath", { enumerable: true, get: function () { return stylable_resolver_1.isInPath; } });
Object.defineProperty(exports, "StylableResolver", { enumerable: true, get: function () { return stylable_resolver_1.StylableResolver; } });
var diagnostics_1 = require("./diagnostics");
var memory_minimal_fs_1 = require("./deprecated/memory-minimal-fs");
const memory_minimal_fs_2 = require("./deprecated/memory-minimal-fs");
/**@deprecated*/
exports.createMinimalFS = (0, deprecation_1.wrapFunctionForDeprecation)(memory_minimal_fs_2.createMinimalFS, {
    name: `createMinimalFS`,
});
var stylable_value_parsers_1 = require("./stylable-value-parsers");
Object.defineProperty(exports, "SBTypesParsers", { enumerable: true, get: function () { return stylable_value_parsers_1.SBTypesParsers; } });
var value_mapping_1 = require("./deprecated/value-mapping");
Object.defineProperty(exports, "valueMapping", { enumerable: true, get: function () { return value_mapping_1.valueMapping; } });
Object.defineProperty(exports, "rootValueMapping", { enumerable: true, get: function () { return value_mapping_1.rootValueMapping; } });
Object.defineProperty(exports, "stValues", { enumerable: true, get: function () { return value_mapping_1.stValues; } });
Object.defineProperty(exports, "stValuesMap", { enumerable: true, get: function () { return value_mapping_1.stValuesMap; } });
Object.defineProperty(exports, "STYLABLE_NAMED_MATCHER", { enumerable: true, get: function () { return value_mapping_1.STYLABLE_NAMED_MATCHER; } });
Object.defineProperty(exports, "mixinDeclRegExp", { enumerable: true, get: function () { return value_mapping_1.mixinDeclRegExp; } });
Object.defineProperty(exports, "animationPropRegExp", { enumerable: true, get: function () { return value_mapping_1.animationPropRegExp; } });
Object.defineProperty(exports, "STYLABLE_VALUE_MATCHER", { enumerable: true, get: function () { return value_mapping_1.STYLABLE_VALUE_MATCHER; } });
var leftovers_1 = require("./deprecated/leftovers");
var create_stylable_processor_1 = require("./create-stylable-processor");
Object.defineProperty(exports, "createStylableFileProcessor", { enumerable: true, get: function () { return create_stylable_processor_1.createStylableFileProcessor; } });
var stylable_1 = require("./stylable");
var types_1 = require("./types");
var stylable_assets_1 = require("./stylable-assets");
Object.defineProperty(exports, "assureRelativeUrlPrefix", { enumerable: true, get: function () { return stylable_assets_1.assureRelativeUrlPrefix; } });
Object.defineProperty(exports, "collectAssets", { enumerable: true, get: function () { return stylable_assets_1.collectAssets; } });
Object.defineProperty(exports, "fixRelativeUrls", { enumerable: true, get: function () { return stylable_assets_1.fixRelativeUrls; } });
Object.defineProperty(exports, "isAsset", { enumerable: true, get: function () { return stylable_assets_1.isAsset; } });
Object.defineProperty(exports, "isExternal", { enumerable: true, get: function () { return stylable_assets_1.isExternal; } });
Object.defineProperty(exports, "isUrl", { enumerable: true, get: function () { return stylable_assets_1.isUrl; } });
Object.defineProperty(exports, "makeAbsolute", { enumerable: true, get: function () { return stylable_assets_1.makeAbsolute; } });
var functions_1 = require("./functions");
Object.defineProperty(exports, "functionWarnings", { enumerable: true, get: function () { return functions_1.functionWarnings; } });
Object.defineProperty(exports, "resolveArgumentsValue", { enumerable: true, get: function () { return functions_1.resolveArgumentsValue; } });
const functions_2 = require("./functions");
/**@deprecated*/
exports.evalDeclarationValue = (0, deprecation_1.wrapFunctionForDeprecation)(functions_2.evalDeclarationValue, {
    name: `evalDeclarationValue`,
    pleaseUse: `stylable.transformDecl`,
});
var custom_values_1 = require("./custom-values");
Object.defineProperty(exports, "CustomValueStrategy", { enumerable: true, get: function () { return custom_values_1.CustomValueStrategy; } });
Object.defineProperty(exports, "box", { enumerable: true, get: function () { return custom_values_1.box; } });
Object.defineProperty(exports, "createCustomValue", { enumerable: true, get: function () { return custom_values_1.createCustomValue; } });
Object.defineProperty(exports, "getBoxValue", { enumerable: true, get: function () { return custom_values_1.getBoxValue; } });
Object.defineProperty(exports, "isCustomValue", { enumerable: true, get: function () { return custom_values_1.isCustomValue; } });
Object.defineProperty(exports, "stTypes", { enumerable: true, get: function () { return custom_values_1.stTypes; } });
Object.defineProperty(exports, "unbox", { enumerable: true, get: function () { return custom_values_1.unbox; } });
var state_validators_1 = require("./state-validators");
Object.defineProperty(exports, "systemValidators", { enumerable: true, get: function () { return state_validators_1.systemValidators; } });
var native_reserved_lists_1 = require("./native-reserved-lists");
Object.defineProperty(exports, "isCssNativeFunction", { enumerable: true, get: function () { return native_reserved_lists_1.isCssNativeFunction; } });
Object.defineProperty(exports, "nativeFunctionsDic", { enumerable: true, get: function () { return native_reserved_lists_1.nativeFunctionsDic; } });
Object.defineProperty(exports, "nativePseudoClasses", { enumerable: true, get: function () { return native_reserved_lists_1.nativePseudoClasses; } });
Object.defineProperty(exports, "nativePseudoElements", { enumerable: true, get: function () { return native_reserved_lists_1.nativePseudoElements; } });
var resolve_namespace_factories_1 = require("./resolve-namespace-factories");
Object.defineProperty(exports, "noCollisionNamespace", { enumerable: true, get: function () { return resolve_namespace_factories_1.noCollisionNamespace; } });
Object.defineProperty(exports, "packageNamespaceFactory", { enumerable: true, get: function () { return resolve_namespace_factories_1.packageNamespaceFactory; } });
var report_diagnostic_1 = require("./report-diagnostic");
Object.defineProperty(exports, "emitDiagnostics", { enumerable: true, get: function () { return report_diagnostic_1.emitDiagnostics; } });
const visit_meta_css_dependencies_1 = require("./visit-meta-css-dependencies");
/**@deprecated use Stylable.getDependencies in v5*/
exports.visitMetaCSSDependenciesBFS = visit_meta_css_dependencies_1.visitMetaCSSDependenciesBFS;
var murmurhash_1 = require("./murmurhash");
Object.defineProperty(exports, "murmurhash3_32_gc", { enumerable: true, get: function () { return murmurhash_1.murmurhash3_32_gc; } });
const pseudo_states_1 = require("./pseudo-states");
exports.pseudoStates = {
    booleanStateDelimiter: pseudo_states_1.booleanStateDelimiter,
    createBooleanStateClassName: pseudo_states_1.createBooleanStateClassName,
    createStateWithParamClassName: pseudo_states_1.createStateWithParamClassName,
    processPseudoStates: pseudo_states_1.processPseudoStates,
    resolveStateParam: pseudo_states_1.resolveStateParam,
    setStateToNode: pseudo_states_1.setStateToNode,
    stateErrors: pseudo_states_1.stateErrors,
    stateMiddleDelimiter: pseudo_states_1.stateMiddleDelimiter,
    stateWithParamDelimiter: pseudo_states_1.stateWithParamDelimiter,
    validateStateArgument: pseudo_states_1.validateStateArgument,
    validateStateDefinition: pseudo_states_1.validateStateDefinition,
};
var rule_1 = require("./helpers/rule");
Object.defineProperty(exports, "getRuleScopeSelector", { enumerable: true, get: function () { return rule_1.getRuleScopeSelector; } });
var value_1 = require("./helpers/value");
Object.defineProperty(exports, "getFormatterArgs", { enumerable: true, get: function () { return value_1.getFormatterArgs; } });
Object.defineProperty(exports, "getNamedArgs", { enumerable: true, get: function () { return value_1.getNamedArgs; } });
Object.defineProperty(exports, "getStringValue", { enumerable: true, get: function () { return value_1.getStringValue; } });
Object.defineProperty(exports, "groupValues", { enumerable: true, get: function () { return value_1.groupValues; } });
Object.defineProperty(exports, "listOptions", { enumerable: true, get: function () { return value_1.listOptions; } });
Object.defineProperty(exports, "validateAllowedNodesUntil", { enumerable: true, get: function () { return value_1.validateAllowedNodesUntil; } });
Object.defineProperty(exports, "strategies", { enumerable: true, get: function () { return value_1.strategies; } });
// *** deprecated ***
const selector_1 = require("./helpers/selector");
/**@deprecated*/
exports.isCompRoot = (0, deprecation_1.wrapFunctionForDeprecation)(selector_1.isCompRoot, {
    name: `isCompRoot`,
});
const rule_2 = require("./helpers/rule");
/**@deprecated*/
exports.isChildOfAtRule = (0, deprecation_1.wrapFunctionForDeprecation)(rule_2.isChildOfAtRule, {
    name: `isChildOfAtRule`,
});
/**@deprecated*/
exports.createWarningRule = (0, deprecation_1.wrapFunctionForDeprecation)(rule_2.createWarningRule, {
    name: `createWarningRule`,
});
const resolve_1 = require("./helpers/resolve");
/**@deprecated*/
exports.getOriginDefinition = (0, deprecation_1.wrapFunctionForDeprecation)(resolve_1.getOriginDefinition, {
    name: `getOriginDefinition`,
});
const postcss_ast_extension_1 = require("./deprecated/postcss-ast-extension");
/**@deprecated*/
exports.getDeclStylable = (0, deprecation_1.wrapFunctionForDeprecation)(postcss_ast_extension_1.getDeclStylable, {
    name: `getDeclStylable`,
});
const deprecated_stylable_utils_1 = require("./deprecated/deprecated-stylable-utils");
/**@deprecated*/
exports.scopeSelector = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_stylable_utils_1.scopeSelector, {
    name: `scopeSelector`,
});
/**@deprecated*/
exports.createSubsetAst = deprecated_stylable_utils_1.createSubsetAst;
/**@deprecated*/
exports.removeUnusedRules = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_stylable_utils_1.removeUnusedRules, {
    name: `removeUnusedRules`,
});
/**@deprecated*/
exports.findRule = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_stylable_utils_1.findRule, {
    name: `findRule`,
});
const deprecated_selector_utils_1 = require("./deprecated/deprecated-selector-utils");
/**@deprecated*/
exports.matchSelectorTarget = deprecated_selector_utils_1.matchSelectorTarget;
/**@deprecated*/
exports.fixChunkOrdering = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.fixChunkOrdering, {
    name: `fixChunkOrdering`,
});
/**@deprecated*/
exports.filterChunkNodesByType = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.filterChunkNodesByType, {
    name: `filterChunkNodesByType`,
});
/**@deprecated*/
exports.separateChunks = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.separateChunks, {
    name: `separateChunks`,
});
/**@deprecated*/
exports.separateChunks2 = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.separateChunks2, {
    name: `separateChunks2`,
});
/**@deprecated*/
exports.mergeChunks = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.mergeChunks, {
    name: `mergeChunks`,
});
/**@deprecated*/
exports.matchAtMedia = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.matchAtMedia, {
    name: `matchAtMedia`,
});
/**@deprecated*/
exports.matchAtKeyframes = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.matchAtKeyframes, {
    name: `matchAtKeyframes`,
});
/**@deprecated*/
exports.isImport = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.isImport, {
    name: `isImport`,
});
/**@deprecated*/
exports.isSimpleSelector = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.isSimpleSelector, {
    name: `isSimpleSelector`,
});
/**@deprecated*/
exports.isRootValid = (0, deprecation_1.wrapFunctionForDeprecation)(() => true, {
    name: `isRootValid`,
});
/**@deprecated*/
exports.isGlobal = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.isGlobal, {
    name: `isGlobal`,
});
/**@deprecated*/
exports.createChecker = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.createChecker, {
    name: `createChecker`,
});
/**@deprecated*/
exports.isNested = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.isNested, {
    name: `isNested`,
});
/**@deprecated*/
exports.isNodeMatch = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.isNodeMatch, {
    name: `isNodeMatch`,
});
/**@deprecated*/
exports.traverseNode = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.traverseNode, {
    name: `traverseNode`,
    pleaseUse: `"import { walk } from '@tokey/css-selector-parser'"`,
});
/**@deprecated*/
exports.parseSelector = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.parseSelector, {
    name: `parseSelector`,
    pleaseUse: `"import { parseCssSelector } from '@tokey/css-selector-parser'"`,
});
/**@deprecated*/
exports.stringifySelector = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.stringifySelector, {
    name: `stringifySelector`,
    pleaseUse: `"import { stringifySelector } from '@tokey/css-selector-parser'"`,
});
/**@deprecated*/
exports.createSimpleSelectorChecker = (0, deprecation_1.wrapFunctionForDeprecation)(deprecated_selector_utils_1.createSimpleSelectorChecker, {
    name: `createSimpleSelectorChecker`,
});
//# sourceMappingURL=index-deprecated.js.map